import type { FieldMetadataMessageDescriptorDef } from './types';
import { descriptionField, massField, massUnitField } from './commonFields';
import { msg } from '@lingui/core/macro';

export const currencyField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Currency',
    context: 'The currency of the expenditure.',
  }),
  externalDescription: msg({
    message: 'The currency of the expenditure.',
    context: 'Currency',
  }),
};

export const currencyQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Spend',
    context:
      'The display name for a metric describing the spend on an expenditure.',
  }),
};

export const beaCodeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'BEA code',
    context: 'The display name for BEA code field',
  }),
};

export const expenditureFields = {
  currency: currencyField,
  currency_quantity: currencyQuantityField,
  description_or_memo: descriptionField,
  financial_account_id: {
    displayName: msg({
      message: 'Financial account ID',
      context: 'The display name for financial account ID field',
    }),
  },
  financial_account_name: {
    displayName: msg({
      message: 'Financial account name',
      context: 'The display name for financial account name field',
    }),
  },
  mass: massField,
  mass_unit: massUnitField,
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
